<template>
  <div class="the-role-list-table">
    <el-row type="flex" align="bottom">
      <el-col :span="18">
        <span>年度</span>
        <el-select style="width:100px;" size="mini" v-model="searchCondition.reportYear" @change="reportYearChangeHandle()">
          <el-option v-for="item in reportYearList" :key="item" :label="item" :value="item"/>
        </el-select>
      </el-col>
      <el-col :span="6">
        <el-pagination style="float: right;margin-bottom: 5px;"
                       @size-change="handleSizeChange"
                       @current-change="handleCurrentChange"
                       :page-sizes="[20, 50, 100, 200]"
                       :current-page="pageInfo.pageNum"
                       :page-size="pageInfo.pageSize"
                       layout="total, prev, pager, next"
                       :total="pageInfo.total">
        </el-pagination>
      </el-col>
    </el-row>
    <el-table style="min-height: 480px;"
      class="bpo-sticky-table bpo-main-table"
      v-sticky-scroll-bar
      :data="pageInfo.list" border stripe>
      <el-table-column
        align="center"
        header-align="center"
        label="No"
        :width="70">
        <template slot-scope="scope">
          {{ (pageInfo.pageNum - 1) * pageInfo.pageSize + scope.$index + 1 }}
        </template>
      </el-table-column>
      <el-table-column
        align="left"
        header-align="center"
        prop="usrNm"
        label="CPA姓名"
        width="120"/>
      <el-table-column
        align="left"
        header-align="center"
        prop="orgNm"
        label="担当组织"
        min-width="240"/>
      <el-table-column
        align="right"
        header-align="center"
        prop="reportNum"
        label="报告数量"
        width="120"/>
    </el-table>
    <el-row type="flex" align="bottom">
      <el-col :offset="18" :span="6">
        <el-pagination style="float: right;margin-bottom: 5px;"
                       @size-change="handleSizeChange"
                       @current-change="handleCurrentChange"
                       :page-sizes="[20, 50, 100, 200]"
                       :current-page="pageInfo.pageNum"
                       :page-size="pageInfo.pageSize"
                       layout="total, prev, pager, next"
                       :total="pageInfo.total"
                       >
        </el-pagination>
      </el-col>
    </el-row>
    <el-row :gutter="24">
      <el-col class="col-text-align">
        <el-button size="mini" class="common-clear-button" @click="handleClose()">关 闭</el-button>
      </el-col>
    </el-row>
  </div>
</template>
<script>
export default {
  name: 'ReportAnalysisTable',
  components: {
  },
  props: {
    reportYear: {
      type: String,
      required: true
    },
    reportYearList: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      searchCondition: {
        reportYear: '',
        currentPage: this.$PAGE_NUM,
        pageSize: this.$PAGE_SIZE
      },
      pageInfo: {}
    }
  },
  mounted() {
    this.searchCondition.reportYear = this.reportYear
    this.handleSearch()
  },
  methods: {
    reportYearChangeHandle() {
      this.handleSearch()
    },
    handleClose() {
      this.$emit('close-dialog')
    },
    async handleSearch() {
      this.pageInfo = (await this.axios.post("/project/loadReportAnalysisData", this.searchCondition)).data.retResult
    },
    handleSizeChange: function(val) {
      this.searchCondition.currentPage = this.pageInfo.pageNum
      this.searchCondition.pageSize = val
      this.handleSearch()
    },
    handleCurrentChange: function(val) {
      this.searchCondition.currentPage = val
      this.searchCondition.pageSize = this.pageInfo.pageSize
      this.handleSearch()
    }
  }
}
</script>
